/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { SEO } from "@/components/SEO";
import { SpecLabel } from "@/components/Section";

export default function TermsPage() {
    return (
        <>
            <SEO
                title="Terms of Service"
                description="Terms of service for Elevara Systems. Last updated June 8, 2026."
                path="/terms"
                noindex
            />
            <div
                className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16"
                data-testid="terms-page"
            >
                <SpecLabel>Legal</SpecLabel>
                <h1 className="mt-3 font-display font-extrabold text-4xl sm:text-5xl tracking-tight text-[#0a0b0d]">
                    Terms of Service
                </h1>
                <p className="mt-3 text-sm text-[#4a5562] font-display font-bold uppercase tracking-[0.18em]">
                    Last updated: June 8, 2026
                </p>
            </div>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
                <article
                    data-testid="legal-content"
                    className="rounded-2xl border-2 border-[#0a0b0d]/8 bg-white p-6 sm:p-10 lg:p-14 max-w-4xl mx-auto leading-relaxed text-[#0a0b0d]"
                >
                    <h2 className="font-display text-2xl font-extrabold mt-0">1. Agreement</h2>
                    <p className="mt-3 text-[#4a5562]">
                        By accessing theelevara.com or subscribing to our
                        services, you agree to these Terms.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">2. Services</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Elevara Systems provides digital marketing systems
                        for home service businesses including website
                        design, review management, missed call text-back,
                        marketing automation, local SEO, unified inbox, and
                        business phone services.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">3. Subscription &amp; Payment</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Foundational Advanced plan: $297/month, billed
                        monthly or annually. Annual subscriptions include a
                        complimentary Google My Business Optimization ($450
                        value). Payment is due at the start of each billing
                        cycle.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">4. Cancellation</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Cancel anytime. No contracts, no cancellation fees.
                        Access continues through the end of the current
                        billing period. No refunds for partial periods.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">5. Upsell Services</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Advanced SEO and Google Ads management are only
                        available to active $297/month subscribers. Not
                        available as standalone services.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">6. SMS Consent</h2>
                    <p className="mt-3 text-[#4a5562]">
                        By providing your phone number, you consent to
                        receive text messages from Elevara Systems. Message
                        frequency varies. Message and data rates may apply.
                        Reply STOP to opt out.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">7. Client Responsibilities</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Results depend on your active participation. Elevara
                        Systems provides tools and systems — we do not
                        guarantee specific business outcomes.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">8. Intellectual Property</h2>
                    <p className="mt-3 text-[#4a5562]">
                        All Elevara Systems branding and software are our
                        intellectual property. Website designs created for
                        clients become client property upon full payment
                        and active subscription.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">9. Limitation of Liability</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Total liability shall not exceed the amount paid by
                        the client in the three months preceding the claim.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">10. Indemnification</h2>
                    <p className="mt-3 text-[#4a5562]">
                        You agree to hold Elevara Systems harmless from
                        claims arising from your use of our services.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">11. Governing Law</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Governed by the laws of the State of Florida.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">12. Changes</h2>
                    <p className="mt-3 text-[#4a5562]">
                        We may update these Terms at any time. Continued use
                        constitutes acceptance.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">13. Contact</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Elevara Systems |{" "}
                        <a
                            href="mailto:contact@theelevara.com"
                            className="text-[#188bf6] font-display font-bold hover:underline"
                        >
                            contact@theelevara.com
                        </a>{" "}
                        |{" "}
                        <a
                            href="tel:+19418075580"
                            className="text-[#188bf6] font-display font-bold hover:underline"
                        >
                            941-807-5580
                        </a>{" "}
                        | theelevara.com
                    </p>
                </article>
            </div>
        </>
    );
}
